import * as http from './http';
import { ApiResponse, EcomCustomer } from '../models';
import ApiService from './service';

export class EcomService extends ApiService {
  static ecomTokenUrl = '/api/ecom/customer/authorize/token';
  public async getEcomCustomerToken(
    customer: EcomCustomer
  ): Promise<{ token: string }> {
    const url = `${this.apiDomain}${EcomService.ecomTokenUrl}`;

    const response = await http.post<ApiResponse<{ token: string }>>(
      url,
      customer,
      this.store
    );

    return response?.data?.data;
  }
}
